import { createContext } from 'preact';
import { useContext } from 'preact/hooks';
import type { AppController } from './AppController';

/** Gives every component access to the app's stores and actions. */
export const AppContext = createContext<AppController | null>(null);

export function useApp(): AppController {
  const app = useContext(AppContext);
  if (!app) throw new Error('useApp() must be used inside <AppContext.Provider>');
  return app;
}
